import React from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Paper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import DownloadIcon from '@mui/icons-material/Download';
import IconButton from '@mui/material/IconButton';
import MagellanLogo from 'assets/img/dashboard-magellan-logo.svg';
import { Typography } from '@mui/material';

const ReleaseNotes = () => {
  const releaseNotesMockData = [
    {
      changes: [
        {
          color: 'success',
          type: 'Features',
        },
        {
          color: 'info',
          type: 'Changes',
        },
      ],
      date: '09/22/2022',
      title: 'Swift Version 1.3.0',
    },
  ];
  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        height: { sm: '100vh', xs: 'initial' },
        justifyContent: 'space-around',
        pb: 6,
        pt: 7,
        px: 2,
      }}
    >
      <Box
        style={{ marginTop: 64 }}
        sx={{
          alignItems: 'center',
          display: 'flex',
          flex: '1 0',
          flexDirection: 'column',
          mx: 0,
          my: 0,
        }}
      >
        <Typography style={{ marginBottom: 32, width: '100%' }} variant="h5">
          Release Notes
        </Typography>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            pl: 3,
            pr: 3,
            width: 1000,
          }}
        >
          <Typography color="primary" style={{ flexGrow: 6 }} variant="subtitle2">
            Title
          </Typography>
          <Typography color="primary" style={{ flexGrow: 2 }} variant="subtitle2">
            Date
          </Typography>
        </Box>
        <List>
          {releaseNotesMockData.map(note => (
            <Paper>
              <ListItem disablePadding style={{ marginBottom: 16, padding: 16, width: 1000 }}>
                <Box
                  display="flex"
                  style={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}
                >
                  <Typography color="primary" variant="subtitle1">
                    {note.title}
                  </Typography>
                  <Stack direction="row" spacing={1}>
                    {note.changes.map(c => (
                      <Chip
                        color={c.color}
                        label={c.type}
                        size="small"
                        style={{ fontSize: 12, fontWeight: 600 }}
                        variant="filled"
                      />
                    ))}
                  </Stack>
                  <Typography color="primary" variant="body2">
                    {note.date}
                  </Typography>
                  <IconButton
                    aria-label="delete"
                    color="primary"
                    href="/downloads/MagellanSwiftReleaseNotes_September2022.pdf"
                    target="_blank"
                  >
                    <DownloadIcon />
                  </IconButton>
                </Box>
              </ListItem>
            </Paper>
          ))}
        </List>
      </Box>
      <Box
        sx={{
          alignItems: 'flex-end',
          display: 'flex',
          flex: '1 0',
          justifyContent: 'center',
          mx: 0,
          my: 2,
        }}
      >
        <img alt="Magellan Midstream Partners, L.P." src={MagellanLogo} />
      </Box>
    </Box>
  );
};

export default ReleaseNotes;
